var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineCheckup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V6.25H2V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.75V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V7.75H2ZM9.98829 10.2501C10.2202 10.2465 10.4408 10.3504 10.5857 10.5315L13.9449 14.7306L15.376 12.584C15.5151 12.3753 15.7492 12.25 16 12.25H19C19.4142 12.25 19.75 12.5858 19.75 13C19.75 13.4142 19.4142 13.75 19 13.75H16.4014L14.624 16.416C14.4913 16.6151 14.2716 16.7389 14.0325 16.7493C13.7935 16.7597 13.5638 16.6554 13.4143 16.4685L10.0191 12.2245L7.6 15.45C7.45836 15.6389 7.23607 15.75 7 15.75H5C4.58579 15.75 4.25 15.4142 4.25 15C4.25 14.5858 4.58579 14.25 5 14.25H6.625L9.4 10.55C9.53917 10.3644 9.75636 10.2537 9.98829 10.2501Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineCheckup);
export default __webpack_public_path__ + "static/media/online-checkup.c016fb5b8747891740e06acaa176c96d.svg";
export { ForwardRef as ReactComponent };